
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.86 16.78c.398.23.533.74.303 1.138a2.5 2.5 0 01-4.326 0 .833.833 0 011.389-.917l.107.163a.833.833 0 001.334 0l.054-.082a.833.833 0 011.139-.303zM9 .832a5.833 5.833 0 015.833 5.834c0 2.416.436 4.232 1.149 5.538.238.437.488.78.732 1.037l.063.064.1.097.067.056.018.014c.659.44.387 1.442-.365 1.522L16.5 15h-15c-.792 0-1.122-.986-.54-1.469l.096-.072.067-.056.1-.097.063-.064c.244-.258.494-.6.732-1.037.677-1.24 1.104-2.942 1.145-5.18l.004-.358A5.833 5.833 0 019 .833zM9 2.5a4.167 4.167 0 00-4.163 3.986l-.004.18c0 2.688-.501 4.779-1.351 6.337l-.116.205-.076.125h11.42l-.076-.125-.116-.205c-.81-1.484-1.303-3.45-1.348-5.956l-.003-.38-.004-.181A4.167 4.167 0 009 2.5z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    